import React, {PureComponent} from 'react';
import Select from './ui/Select';
import ResultPanel from './ResultPanel';
import PropTypes from 'prop-types';
import Constants from './../constants';

export default class LeftSide extends PureComponent {
    constructor(props, state) {
        super(props, state);
        this.state = {
            results: []
        };
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.results === this.state.results) {
            this.setState({
                results: this.props.results
            });
        }
    };

    onSelectApp = e => {
        return fetch(Constants.SERVER_PATH + `apps?q=${e.target.value}`, {method: 'GET'})
            .then(resp => {
                return resp.json();
            })
            .then(json => {
                this.setState({results: json.result});
                return {results: json.result};
            })
            .catch(error => {
                console.error('apps?q= error ' + error);
            });
    };

    render() {
        return (
            <div className="left-column">
                <div className="row row-indent">
                    <label>Организация</label>
                    <Select.Async
                        onChange={this.props.onChange}
                        value={this.props.selected.id < 0 ? this.props.selected.id : this.props.selected}
                        labelKey="name" valueKey="id"
                        loadOptions={this.props.serversList}
                    />
                </div>
                <div className="row row-indent">
                    <input type="search" onChange={this.onSelectApp} placeholder="Поиск приложения"/>
                </div>
                <div className="row">
                    <ResultPanel
                        results={this.state.results}
                        orgs={this.props.orgs}
                        filter={this.state.filter}
                        selection={this.state.selected}
                        activePage={this.state.activePage}
                        onSelectRow={this.onSelectRow}
                        onSelectPage={this.onSelectPage}
                        handleSelectApp={this.props.handleSelectApp.bind(this)}
                        onClose={() => this.setState({results: []})}/>
                </div>
            </div>
        );
    };
}

LeftSide.propTypes = {
    serversList: PropTypes.func,
    onChange: PropTypes.func,
    selected: PropTypes.object,
    results: PropTypes.array,
    handleSelectApp: PropTypes.func,
    orgs: PropTypes.array
};


// WEBPACK FOOTER //
// ./src/components/left_side.js